import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TextFieldWrapper from '../../../../components/TextFieldWrapper/TextFieldWrapper';
import { confirmAlert } from '../../../../../services/mini/alanConfirmAlert';
import ConfirmPopup from '../../../../components/ConfirmPopup/ConfirmPopup';
import ProgressLoader from '../../../../components/ProgressLoader/ProgressLoader';
import capitalize from '../../../../../services/mini/capitalize';
import {Loader} from '../../../../components/Loader/Loader';
import getErrorMsg from '../../../../../services/mini/getErrorMsg';
import { BILLING_PROMOCODE } from '../../../../../const/billingTypes';
import billingEvents from '../../../../../const/billingEvents';
import GaService from '../../../../../services/GaService';

class PromoCodeForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            promoCode: '',
            promoCodeFieldError: null,
            promoCodeFieldInfo: null,

            isPromoCodeApplying: false
        };

        this.maxFieldLength = 50;

        this.submit = this.submit.bind(this);
        this.onTextInputChange = this.onTextInputChange.bind(this);
        this.onTextInputBlur = this.onTextInputBlur.bind(this);
    }

    getTrackInfo(status) {
        const {
            isInitialBilling,
            contentId,
            contentVersion
        } = this.context;

        return {
            paymentMethod: BILLING_PROMOCODE,
            isInitialBilling: isInitialBilling,
            contentId,
            contentVersion,
            paymentStatus: status
        };
    }

    trackPayment(status) {
        const {
            trackPaymentStart = _.noop(),
        } = this.context;

        trackPaymentStart(this.getTrackInfo(status));
    }

    async submit(ev) {
        const { applyPromoCode, campaignName } = this.props;
        const { promoCode } = this.state;
        const {
            trackPaymentError = _.noop(),
            trackPaymentSuccess = _.noop(),
        } = this.context;

        if (!this.validate()) {
            this.trackPayment(billingEvents.clientValidationFailed);
            return;
        }

        this.trackPayment(billingEvents.paymentBtnClicked);

        this.setState({ isPromoCodeApplying: true });

        applyPromoCode({ promoCode }).then((msg) => {
            trackPaymentSuccess(this.getTrackInfo());
            GaService.sendPaymentEvent({
                promoCode: promoCode,
                paymentType: BILLING_PROMOCODE,
                campaignName,
            });

            confirmAlert({
                customUI: ({ onClose }) => {
                    this.setState({ isPromoCodeApplying: false, promoCode: '' });
                    return (
                        <ConfirmPopup
                            onClose={() => {
                                onClose();
                                if (this.props.onBillingFinishedCb) {
                                    this.props.onBillingFinishedCb();
                                }
                            }}
                            hideCancelBtn={true}
                            okBtnCb={() => {
                                onClose();
                                if (this.props.onBillingFinishedCb) {
                                    this.props.onBillingFinishedCb();
                                }
                            }}
                            type="success"
                            title="Promo code has been applied"
                            message={
                                <React.Fragment>
                                    Promo code has been applied successfully.<br />
                                    <b>{capitalize(msg)}</b>
                                </React.Fragment>}
                        />
                    );
                }
            });
        }, (err) => {
            this.setState({ isPromoCodeApplying: false });
            trackPaymentError(this.getTrackInfo(billingEvents.promoCodeApplyError + getErrorMsg(err)));
        });

    }

    onTextInputChange(e) {
        const field = e.target.name;
        let newState = this.state;
        newState[field] = e.target.value;
        this.setState(newState);
    }

    onTextInputBlur() {
        this.validate();
    }

    validate() {
        const {
            promoCode,
        } = this.state;
        let promoCodeFieldError = null,
            promoCodeFieldInfo = null;

        if (!promoCode) {
            promoCodeFieldError = 'Promo Code should not be empty';
        }

        promoCodeFieldInfo = this.validateFieldLength();

        this.setState({
            promoCodeFieldError: promoCodeFieldError,
            promoCodeFieldInfo: promoCodeFieldInfo,
        });

        return promoCodeFieldError === null &&
            promoCodeFieldInfo === null;
    }

    validateFieldLength() {
        const {
            promoCode,
        } = this.state;
        let promoCodeInfo = null;

        if (promoCode.length > this.maxFieldLength) {
            return `Max Promo Code length: ${this.maxFieldLength} characters`;
        }

        return promoCodeInfo;
    }

    render() {
        const {
            promoCode,
            promoCodeFieldError,
            promoCodeFieldInfo,
            isPromoCodeApplying,
        } = this.state;

        return (
            <div className="promo-code-form">
                {isPromoCodeApplying && <Loader theme="dark" size="medium" center={true} appearWithFade={true} />}
                <TextFieldWrapper placeholder="Promo code"
                    label="Promo code"
                    name="promoCode"
                    id="promoCode"
                    className={`billing-promocode ${isPromoCodeApplying && 'disabled'} text-field-with-left-margin`}
                    value={promoCode}
                    error={promoCodeFieldError}
                    info={promoCodeFieldInfo}
                    onChange={this.onTextInputChange}
                    onEnter={this.submit}
                    onBlur={this.onTextInputBlur} />

                <div className="popup-form_btns">
                    <div onClick={this.submit}
                        className={`popup-form_btn action-btn big only-btn ${isPromoCodeApplying && 'disabled'}`}>
                        Apply
                    </div>
                </div>

            </div>
        );
    }
}

PromoCodeForm.contextTypes = {
    trackPaymentStart: PropTypes.func,
    trackPaymentError: PropTypes.func,
    trackPaymentSuccess: PropTypes.func,
    isInitialBilling: PropTypes.bool,
    contentId: PropTypes.string,
    contentVersion: PropTypes.string,
};

export default PromoCodeForm;
